import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
    status: false,
    products: [],
    delivery: false,
    order: false,
}

export const isCartAvailable = createAsyncThunk('cart/availability', async ({products})=>{
    const response = await axios({
        method: 'post',
        url: process.env.NEXT_PUBLIC_API + '/api/cart/availability',
        data: { products},
        headers: { 'Content-Type': 'application/json'},
        withCredentials: true,
    });
    return response.data;
});


const cartSlice = createSlice( {
    name: 'cart',
    initialState,
    reducers: {
        saveProducts: (state, action) => {
            const {products, status} = action.payload;
            state.products = products;
            state.status = status;
        },
        setStatus: (state, action) =>{
            state.status = action.payload; 
        },
        addDelivery: (state, action) =>{
            state.delivery = action.payload.delivery;
            state.status = 'shipping';
        },
        saveOrder: (state, action) =>{
            const {gateway, hash, transaction} = action.payload;
            state.order = {
                gateway,
                hash,
                transaction,
            };
            state.status = 'charge';
        },
        emptyCart : (state, action) =>{
            state.order = false;
            state.products = [];
            state.delivery = false;
            state.status = 'empty';
        },
        retryPayment : (state, action) =>{
            const {gateway, hash, transaction} = action.payload;
            state.order = {
                gateway,
                hash,
                transaction,
            };
            state.products = [];
            state.delivery = false;
            state.status = 'charge';
        }
    },
    extraReducers: (builder) => {
    builder
        .addCase(isCartAvailable.fulfilled, (state, action)=>{
            const {status, list} = action.payload;
            if (status) {
                let newProducts = [...state.products];
                list.forEach( el =>{
                    newProducts = newProducts.map( prod =>{ 
                        let res;
                        if (prod.type==el.type && prod.id==el.id) {
                            res = {...prod, user_id: el.user_id, isAvailable: el.isAvailable};
                            if (el.isAvailable) {
                                res.price = el.price;
                            }
                        } else {
                            res = prod;
                        }
                        return res;
                    });
                });

                state.products = newProducts;
                state.status = 'checked';
            } 
        });
}
});

export const {saveProducts, setStatus, addDelivery, saveOrder, emptyCart, retryPayment} = cartSlice.actions;
export default cartSlice.reducer;
